import { JornadaLaboral, ResponseRequest, ResponseRequestGeneric, WrapperResponse } from 'components/Types/GeneralTypes';
import { alertService } from 'components/Varios/alert_service'
import Cargando from 'components/Varios/Cargando';

import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { authenticationService } from 'services/authentication.service';
import AlertNew, { TiposAlerta } from 'components/Varios/AlertNew'
import "../../../assets/scss/RegistroEntradaSalidaAlmuerzo.scss"
import CalendarComponent from './CalendarComponent';


export const OPCIONES_SELECT_MARCACION = ["Inicio del receso/almuerzo", "Fin del receso/almuerzo", "Inicio y fin del receso/almuerzo"];
export const OPCIONES_SELECT_MOTIVO = ["Descuido personal", "Distracción", "Olvido", "Omisión involuntaria"];
export const TIEMPO_MIN_ALMUERZO = 25;
export const TIEMPO_MAX_ALMUERZO = 30;
export const MENSAJE_ADVERTENCIA_LAPSO_SOLICITUD = "Usted tiene hasta un máximo de 2(dos) días para solicitar la justificación de no marcación y/o recuperación de tiempo no laborado.Recuerde que las solicitudes de recuperación de tiempo no laborado deben estar autorizadas por su Directivo, previo a la fecha de recuperación.";




export const ESTADO_REGISTRO_JUSTIFICADO = "Justificado";

export const ESTADO_EXCESO_RECESO = "Jornada Excedida Receso";
export const ESTADO_JORNADA_INCUMPLIDA = "Jornada Incompleta de Labores"
export const ESTADO_AUSENCIA_LABORES = "Ausencia de Marcación Labores";
export const ESTADO_AUSENCIA_RECESO = "Ausencia de Marcación Receso";
export const ESTADO_REGISTRO_INCOMPLETO = "Registro incompleto";
export const ESTADO_JORNADA_COMPLETA_RECESO = "Jornada Completa de receso";
export const ESTADO_JORNADA_COMPLETA_LABORES = "Jornada Completa de labores";

export const ESTADO_JORNADA_INCUMPLIDA_MARCACION_DEL_DIA = "J. Incompleta Labores (sujeta a revisión de permisos, licencias, comisiones, vacaciones, justific y recuperac)"


export const ESTADOS_CON_NOVEDAD = [ESTADO_EXCESO_RECESO, ESTADO_JORNADA_INCUMPLIDA, ESTADO_AUSENCIA_LABORES, ESTADO_AUSENCIA_RECESO, ESTADO_REGISTRO_INCOMPLETO, ESTADO_JORNADA_INCUMPLIDA_MARCACION_DEL_DIA]


export default function HistorialMarcaciones() {



    const [loadingDatos, setloadingDatos] = useState<boolean>(false)




   

    if (loadingDatos) {
        return <Cargando />
    }





    return (
        <div className="content">
            <h3 className="title">Historial de Marcaciones</h3>
{/* 
            <Row className="">
                <Col >
                    <AlertNew
                        cabeceraTitulo={"¡¡ADVERTENCIA!!"}
                        mensaje={MENSAJE_ADVERTENCIA_LAPSO_SOLICITUD}
                        tipo={TiposAlerta.ADVERTENCIA}
                        oncloseElement={() => { }}
                    />
                </Col>
            </Row> */}



            <Row>
  {/* historial */}
        <Col>
          {/* <h5 className="title">Calendario de Jornada Laboral</h5> */}
          {/* <p>${authenticationService.currentUserValue.identificacion}</p> */}
          <CalendarComponent cedula={authenticationService.currentUserValue.identificacion } canNavigate={true}     />
          </Col>
      </Row>

           

        </div>
    )
}